export default __webpack_public_path__ + "static/media/huobi.50e484e5.svg";